import { render, staticRenderFns } from "./DashboardMaintenancePage.vue?vue&type=template&id=5defdaf8"
import script from "./DashboardMaintenancePage.vue?vue&type=script&lang=ts"
export * from "./DashboardMaintenancePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5defdaf8')) {
      api.createRecord('5defdaf8', component.options)
    } else {
      api.reload('5defdaf8', component.options)
    }
    module.hot.accept("./DashboardMaintenancePage.vue?vue&type=template&id=5defdaf8", function () {
      api.rerender('5defdaf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/data_quality_dataplex/DashboardMaintenancePage.vue"
export default component.exports